export default "__VITE_ASSET__mkMaiTJa__"